export default __webpack_public_path__ + "static/media/ad-5.da73c271.jpg";